export default "__VITE_ASSET__fb400a78__"